<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {isEqual} from '@/utils/helpers'

    @Component
    export class SearchPageMixin extends Vue {
        needNewSearch() {
            return (
                !isEqual(this.productStore.searchRequest, this.searchRequest) ||
                this.isOffersExpired() ||
                !this.productStore.hasOffers
            )
        }

        isOffersExpired() {
            return this.productStore.isOffersExpired()
        }

        get searchRequest() {
            return this.productRuntimeStore.searchRequestFromQuery(this.$route.query)
        }
    }

    export default SearchPageMixin
</script>
